// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useGetParam } from "hooks/useGetParam";
import useQueryParam from "hooks/useQueryParam";
import { GET_PARAMS } from "constants/popupConfig";
import { useMemo } from "react";
import { Geos } from "types/localization";
import { useSelector } from "react-redux";
import * as gamesSelector from "redux/game/selectors";
import { getDescription } from "../getDescription";
import { getTitle } from "../getTitle";
import { getHreflang } from "../getHreflang";

export type CustomMetadata = {
  property: string;
  content?: string | null;
};

interface Props {
  title?: string;
  description?: string;
  type?: string;
  pathname?: string;
  keyWords?: string[];
  customMeta?: CustomMetadata[];
}

export const SEO: React.FC<Props> = (props) => {
  const { title, pathname, customMeta, keyWords } = props;

  const { lang, category, game } = useGetParam();
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const games = useSelector(gamesSelector.games);
  const params = useParams();

  const currentGame = useMemo(() => {
    if (games && params.game) {
      return games.find((g) => g.urlAlias === params.game) || null;
    }
    return null;
  }, [games, params]);

  const geo = useMemo(() => {
    if (lang) {
      return Geos[lang];
    }
    return Geos["/"];
  }, [lang]);

  const currentTitle = getTitle(
    title,
    geo,
    category,
    game,
    providersQuery,
    currentGame,
  );
  const currentDescription = getDescription(
    geo,
    category,
    game,
    providersQuery,
    currentGame,
  );

  return (
    <Helmet
      title={currentTitle}
      link={[
        ...getHreflang({
          path: pathname,
        }),
      ]}
      meta={[
        { name: "description", content: currentDescription },
        {
          name: "keywords",
          content: `${import.meta.env.VITE_APP_PROJECT_NAME}${
            keyWords?.length ? `, ${keyWords.join(", ")}` : ""
          }`,
        },
      ]}
    >
      {customMeta &&
        customMeta.map(
          ({ property, content }) =>
            content && (
              <meta
                key={property + content}
                property={property}
                content={content}
              />
            ),
        )}
    </Helmet>
  );
};
